import React from 'react';
import './ViceChancellor.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const ViceChancellor = () => {
  return (
    <div className="vice-chancellor-page">
      <Navbar />

      <div id="vice-chancellor-container">
        <div id="page-header">
          <h1>Hon'ble  Vice-Chancellor</h1>
          <p className="vc-subtitle">
            Rayalaseema University
          </p>
          <div id="header-underline"></div>
        </div>

        <div id="vc-main-profile">
          <div id="vc-image">
            <img src="/person/vicechancellor1.JPG" alt="Prof. V. Venkata Basava Rao" />
          </div>

          <div id="vc-details">
            <h2>Prof. V. Venkata Basava Rao</h2>
            <p id="vc-title">Hon'ble Vice Chancellor</p>

            <div id="vc-info">
              <p><strong>Born:</strong> July 7, 1964, Mangalagiri, Guntur District, AP</p>
              <p><strong>Education:</strong> B.Tech (Chemical Engineering, Andhra University, 1986), M.Tech & Ph.D. (IIT-Kharagpur, 1988 & 1991)</p>
              <p><strong>Experience:</strong> Over 30 years in academia, research, and administration</p>
              <p><strong>Specialization:</strong> Chemical Engineering, Food Technology</p>
            </div>

            {/* <div id="vc-contact">
              <h3>Contact Information</h3>
              <p><i className="fas fa-envelope"></i> vc@rayalaseemauniversity.ac.in</p>
              <p><i className="fas fa-phone"></i> +91-8518-221310</p>
            </div> */}
          </div>
        </div>

        <div id="vc-content">
          <div className="section">
            <h3>Career Journey</h3>
            <div className="career-list">
              <p><strong>1991-1995:</strong> Bharat Dynamics Limited, Bhanur</p>
              <p><strong>1995-1997:</strong> Assistant Professor, JNTU College of Engineering, Anantapur</p>
              <p><strong>1997-2024:</strong> Associate Professor → Professor → Senior Professor, Osmania University</p>
              <p><strong>2017-2018:</strong> Director, Dr. APJ Abdul Kalam IIIT-Ongole, RGUKT (on lien)</p>
              <p><strong>2024-Present:</strong> Hon'ble Vice Chancellor, Rayalaseema University</p>
            </div>
          </div>

          <div className="section">
            <h3>Key Administrative Roles at Osmania University</h3>
            <ul>
              <li>Principal, University College of Technology</li>
              <li>Dean, Faculty of Technology & Pharmacy</li>
              <li>Director of Evaluation</li>
              <li>Head of Departments: Food Technology, Pharmacy, Chemical Engineering</li>
              <li>Chairman, Board of Studies (Technology, Chemical Engineering, Food Technology & Hotel Management)</li>
              <li>Coordinator, World Bank Projects, TEQIP & CoE (₹25 crores secured)</li>
            </ul>
          </div>

          <div className="section">
            <h3>Academic Achievements</h3>
            <div className="stats">
              <span><strong>31</strong> Ph.D. Scholars Supervised</span>
              <span><strong>78</strong> M.Tech Theses Guided</span>
              <span><strong>67</strong> Technical Papers Published</span>
              <span><strong>16</strong> International Conferences</span>
            </div>
            <p><strong>Fellow of The Royal Society of Chemistry (RSC), 2024</strong></p>
          </div>

          <div className="section">
            <h3>Awards & Recognition</h3>
            <ul>
              <li><strong>1999:</strong> Young Scientist Award by APCOST</li>
              <li><strong>2008:</strong> Ranked 5th among "Top 10 Best Professors" by M/s. 24/7 Customer in Education</li>
              <li><strong>2009:</strong> "The Hindustan Lever's Outstanding Chemical Engineer of the Year" Award</li>
            </ul>
          </div>

          <div className="section">
            <h3>International Collaborations</h3>
            <p><strong>Canada:</strong> University of New Brunswick (2006), University of Western Ontario (2009)</p>
            <p><strong>USA:</strong> University of Louisville (2007), West Virginia University (2016), Arizona State University (2023-2025)</p>
            <p><strong>Germany:</strong> University of Hamburg-Harburg (2008)</p>
            <p><strong>Singapore:</strong> National University of Singapore (2009)</p>
          </div>

          <div className="section">
            <h3>Professional Associations</h3>
            <p><strong>Indian Institute of Chemical Engineers (IIChE):</strong> Former National President (2020), Life Fellow</p>
            <p><strong>Institution of Engineers (IEI):</strong> Fellow & Chartered Engineer (FIE)</p>
            <p><strong>American Institute of Chemical Engineers (AIChE):</strong> Senior Member</p>
            <p><strong>Indian Mathematical Society (IMS):</strong> Life Member</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ViceChancellor;